export const GET_PERSONNEL_PENDING = "GET_PERSONNEL_PENDING";
export const GET_MORE_PERSONNEL_PENDING = "GET_MORE_PERSONNEL_PENDING";
export const GET_PERSONNEL_SUCCESS = "GET_PERSONNEL_SUCCESS";
export const GET_MORE_PERSONNEL_SUCCESS = "GET_MORE_PERSONNEL_SUCCESS";
export const RESET_PERSONNEL = "RESET_PERSONNEL";
export const GET_PERSONNEL_DETAILS = "GET_PERSONNEL_DETAILS";
export const RESET_PERSONNEL_DETAILS = "RESET_PERSONNEL_DETAILS";
